<template>
  <div>
    <div class="premium-detail-section">
      <div class="premium-detail-section__title">
        Kullanıcı ve paket
      </div>
      <div class="premium-detail-grid">
        <div class="premium-detail-item">
          <span>Kullanıcı</span>
          <strong>{{ premiumOwnerResolved(selectedPremium) ? (selectedPremium.fullName || '-') : 'Sahibi bilinmiyor' }}</strong>
          <small v-if="premiumOwnerResolved(selectedPremium)">#{{ selectedPremium.id }} · {{ selectedPremium.email }}</small>
        </div>
        <div class="premium-detail-item">
          <span>Paket</span>
          <strong>{{ premiumPlanPhaseLabel(selectedPremium) }}</strong>
          <small>{{ packageMeta(selectedPremium) }}</small>
        </div>
        <div class="premium-detail-item">
          <span>Platform</span>
          <strong>{{ platformLabel(resolvedPlatform(selectedPremium)) }}</strong>
        </div>
        <div class="premium-detail-item">
          <span>Premium tipi</span>
          <strong>{{ selectedPremium.customPremium ? 'Manuel' : 'Store' }}</strong>
          <small>{{ selectedPremium.recurring ? 'Yenilenen abonelik' : 'Tek dönem' }}</small>
        </div>
        <div class="premium-detail-item">
          <span>Deneme geçmişi</span>
          <strong>{{ yesNoLabel(selectedPremium.trialUsed) }}</strong>
        </div>
        <div class="premium-detail-item">
          <span>Ücretsiz deneme aktif</span>
          <strong>{{ yesNoLabel(selectedPremium.trialActive) }}</strong>
        </div>
        <div class="premium-detail-item">
          <span>İlk ücretli dönüşüm bekleniyor</span>
          <strong>{{ yesNoLabel(selectedPremium.trialConversionPending) }}</strong>
        </div>
        <div class="premium-detail-item">
          <span>Ödeme tokenı</span>
          <strong class="font-mono">{{ selectedPremium.paymentTokenMasked || '-' }}</strong>
        </div>
      </div>
    </div>

    <div class="premium-detail-section">
      <div class="premium-detail-section__title">
        Mağaza doğrulaması
      </div>
      <div class="premium-detail-grid">
        <div class="premium-detail-item">
          <span>Provider / ortam</span>
          <strong>{{ platformLabel(selectedPremium.storeEvidenceProvider) }}</strong>
          <small>{{ selectedPremium.storeEvidenceEnvironment || '-' }}</small>
        </div>
        <div class="premium-detail-item">
          <span>Store ürünü</span>
          <strong class="font-mono">{{ selectedPremium.storeEvidenceProductId || '-' }}</strong>
        </div>
        <div class="premium-detail-item">
          <span>Store durumu</span>
          <strong>{{ selectedPremium.storeEvidenceState || '-' }}</strong>
          <small>{{ selectedPremium.storeEvidenceBillingPhase || '-' }}</small>
        </div>
        <div class="premium-detail-item">
          <span>Store trial sinyali</span>
          <strong>{{ evidenceBooleanLabel(selectedPremium.storeEvidenceFreeTrial) }}</strong>
          <small>{{ evidenceOfferLabel(selectedPremium) }}</small>
        </div>
        <div class="premium-detail-item">
          <span>Doğrulanmış fiyat</span>
          <strong>{{ formatCurrency(selectedPremium.storeEvidencePrice, selectedPremium.storeEvidenceCurrency) }}</strong>
          <small
            v-if="selectedPremium.contractStorePriceMismatch"
            class="error--text"
          >Sözleşme snapshot fiyatından farklı; audit düzeltmesi gerekli</small>
        </div>
        <div class="premium-detail-item">
          <span>Store bitişi</span>
          <strong>{{ formatTimestamp(selectedPremium.storeEvidenceExpiry) }}</strong>
        </div>
        <div class="premium-detail-item">
          <span>Son doğrulama</span>
          <strong>{{ formatTimestamp(selectedPremium.storeEvidenceCheckedAt) }}</strong>
          <small v-if="selectedPremium.storeEvidenceVersion">
            {{ selectedPremium.storeEvidenceSource || 'STORE' }} · Evidence v{{ selectedPremium.storeEvidenceVersion }}
          </small>
        </div>
      </div>
    </div>

    <div class="premium-detail-section">
      <div class="premium-detail-section__title">
        Tarihler
      </div>
      <div class="premium-detail-grid">
        <div class="premium-detail-item">
          <span>Satın alma tarihi</span>
          <strong>{{ formatTimestamp(selectedPremium.premiumPurchaseDate) }}</strong>
        </div>
        <div class="premium-detail-item">
          <span>Premium başlangıcı</span>
          <strong>{{ formatTimestamp(selectedPremium.premiumStartDate) }}</strong>
        </div>
        <div class="premium-detail-item">
          <span>Erişim sonu</span>
          <strong>{{ formatTimestamp(selectedPremium.premiumAccessEndDate) }}</strong>
        </div>
        <div class="premium-detail-item">
          <span>Store bitişi</span>
          <strong>{{ formatTimestamp(selectedPremium.premiumStoreEndDate) }}</strong>
        </div>
        <div class="premium-detail-item">
          <span>Recovery sonu</span>
          <strong>{{ formatTimestamp(selectedPremium.premiumRecoveryEndDate) }}</strong>
        </div>
        <div class="premium-detail-item">
          <span>Kayıt / güncelleme</span>
          <strong>{{ formatTimestamp(selectedPremium.premiumCreatedAt) }}</strong>
          <small>{{ formatTimestamp(selectedPremium.premiumUpdatedAt) }}</small>
        </div>
      </div>
    </div>

    <div class="premium-detail-section">
      <div class="premium-detail-section__title">
        Satın alma sözleşmesi
      </div>
      <div class="premium-detail-grid">
        <div class="premium-detail-item">
          <span>Sözleşme versiyonu</span>
          <strong>{{ selectedPremium.contractVersion || '-' }}</strong>
        </div>
        <div class="premium-detail-item">
          <span>Sözleşme paketi</span>
          <strong>{{ selectedPremium.contractPackageLabel || '-' }}</strong>
          <small v-if="selectedPremium.contractPackageId">#{{ selectedPremium.contractPackageId }}</small>
        </div>
        <div class="premium-detail-item">
          <span>Dönem</span>
          <strong>{{ selectedPremium.contractPackagePeriod || '-' }}</strong>
        </div>
        <div class="premium-detail-item">
          <span>Sözleşme fiyatı</span>
          <strong>{{ formatCurrency(selectedPremium.contractPackagePrice, selectedPremium.contractPackageCurrency) }}</strong>
        </div>
        <div class="premium-detail-item">
          <span>Ödeme yöntemi</span>
          <strong>{{ selectedPremium.contractPaymentMethod || '-' }}</strong>
        </div>
        <div class="premium-detail-item">
          <span>Kabul tarihi</span>
          <strong>{{ formatTimestamp(selectedPremium.contractAcceptedAt) }}</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PremiumRecordDetails',
  props: { selectedPremium: { type: Object, required: true } },
  methods: {
    stateLabel(value) {
      if (!value) {
        return 'Bilinmiyor'
      }

      return {
        ACTIVE: 'Aktif',
        PAYMENT_RETRY_WITH_ACCESS: 'Retry + erişim',
        ON_HOLD_NO_ACCESS: 'On hold',
        EXPIRED: 'Bitmiş',
      }[value] || value
    },
    premiumOwnerResolved(item) {
      return item?.ownerResolved === true
        || (item?.ownerResolved === undefined && item?.attachedToUser === true)
    },
    stateColor(value) {
      return {
        ACTIVE: 'success',
        PAYMENT_RETRY_WITH_ACCESS: 'info',
        ON_HOLD_NO_ACCESS: 'warning',
        EXPIRED: 'error',
      }[value] || 'secondary'
    },
    stateTextColor(value) {
      return value === 'PAYMENT_RETRY_WITH_ACCESS' ? 'white' : undefined
    },
    platformLabel(value) {
      return {
        IOS: 'iOS',
        ANDROID: 'Android',
        MANUAL: 'Manuel',
        UNKNOWN: 'Bilinmiyor',
      }[value] || value || '-'
    },
    resolvedPlatform(item) {
      if (item?.customPremium) {
        return 'MANUAL'
      }
      if (item?.premiumPlatform && item.premiumPlatform !== 'UNKNOWN') {
        return item.premiumPlatform
      }

      return item?.premiumDeviceType || 'UNKNOWN'
    },
    packageMeta(item) {
      const parts = []
      if (item.packageId) {
        parts.push(`#${item.packageId}`)
      }
      if (item.packageDay) {
        parts.push(`${item.packageDay} gün`)
      }
      if (item.packagePrice !== null && item.packagePrice !== undefined) {
        parts.push(this.formatCurrency(item.packagePrice))
      }

      return parts.join(' · ') || 'Paket detayı yok'
    },
    premiumPlanPhaseLabel(item) {
      const plan = item?.packageTime || item?.contractPackageLabel || '-'
      if (item?.trialActive) {
        return `${plan} · 3 günlük ücretsiz deneme aktif`
      }
      if (item?.trialConversionPending) {
        return `${plan} · ücretli dönüşüm bekleniyor`
      }

      return plan
    },
    yesNoLabel(value) {
      return value ? 'Evet' : 'Hayır'
    },
    evidenceBooleanLabel(value) {
      if (value === null || value === undefined) {
        return 'Doğrulanmadı'
      }

      return value ? 'Ücretsiz deneme' : 'Ücretli faz'
    },
    evidenceOfferLabel(item) {
      return [item?.storeEvidenceOfferType, item?.storeEvidenceOfferDiscountType]
        .filter(Boolean)
        .join(' · ') || 'Teklif sinyali yok'
    },
    formatCurrency(value, currency = 'TRY') {
      if (value === null || value === undefined || value === '') {
        return '-'
      }

      try {
        return new Intl.NumberFormat('tr-TR', {
          style: 'currency',
          currency: currency || 'TRY',
          maximumFractionDigits: 2,
        }).format(Number(value) || 0)
      } catch (error) {
        return `${Number(value) || 0} ${currency || ''}`.trim()
      }
    },
    formatTimestamp(value) {
      if (!value) {
        return '-'
      }

      return new Intl.DateTimeFormat('tr-TR', {
        dateStyle: 'short',
        timeStyle: 'short',
        timeZone: 'Europe/Istanbul',
      }).format(new Date(value))
    },
  },
}
</script>

<style lang="scss" scoped>
.premium-detail-section + .premium-detail-section {
  margin-top: 28px;
}

.premium-detail-section__title {
  margin-bottom: 12px;
  color: var(--premium-text);
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.premium-detail-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.premium-detail-item {
  display: grid;
  gap: 5px;
  min-height: 90px;
  padding: 15px 16px;
  border: 1px solid var(--premium-border);
  border-radius: 14px;
  background: var(--premium-subtle);
}

.premium-detail-item > span,
.premium-detail-item > small {
  color: var(--premium-muted);
}

.premium-detail-item > strong {
  overflow-wrap: anywhere;
  color: var(--premium-strong);
}

@media (max-width: 760px) {
  .premium-detail-grid { grid-template-columns: 1fr; }
}
</style>
